import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { EmbalagemService } from 'src/app/services/embalagem/embalagem.service';

@Component({
  selector: 'app-lcb-embalagens',
  templateUrl: './lcb-embalagens.component.html',
  styleUrl: './lcb-embalagens.component.css'
})
export class LCBEmbalagensComponent {
  embDocks: DocksModel[] = []
  dateInterval: any
  updateInterval: any

  formSharedData: any

  selectedDockId: number | null = null;

  private readonly DEFAULT_COLOR = '#FFF'
  private readonly ACTIVE_COLOR = '#3CB371'
  private readonly INACTIVE_COLOR = '#FF2340'

  showIntegrationForm: boolean = false;
  planningIsVisible: boolean = false;
  Date = Date.now();

  constructor(
    private embService: EmbalagemService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.Date = Date.now();
      this.updateData();
      this.route.params.subscribe(params => {
        if (params['id']) {
          this.selectedDockId = +params['id'];
        }
      })
    }, 5000);
  }

  updateData(): void {
    this.embService.getEmbDocksData().pipe
      (take(1),
        catchError(() => {
          return of({ embDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.embDocks = response.embDocks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }

  ngOnDestroy() {
    clearInterval(this.dateInterval);
    clearInterval(this.updateInterval);
  }

  handleFormData(data: any) {
    this.formSharedData = data
  }

  //* ---------------------- BOTÕES DOCAS ---------------------- *//

  public statusDocks(docks: number): string {
    const dock = this.embDocks.find((t) => t.id == docks);
    if (this.isDockValidAndActive(dock)) {
      switch (dock?.truck) {
        case 0:
          return this.DEFAULT_COLOR
        case 1:
          return this.ACTIVE_COLOR
        default:
          return "Valor no campo 'Truck' inválido"
      }
    } return this.INACTIVE_COLOR
  }

  private isDockValidAndActive(dock: any): boolean {
    return dock && dock.truck !== undefined && dock.status && dock.active == 1
  }

  //* ---------------------- EXIBIÇÃO DO FORM ---------------------- *//

  openPlanning() {
    this.planningIsVisible = !this.planningIsVisible
  }

  openIntegrationFormFromChild() {
    this.showIntegrationForm = true;
  }

  toggleIntegrationForm() {
    this.showIntegrationForm = !this.showIntegrationForm
  }
}

